"use strict";
const config = require('../../../../../config/locales_json/packs/private/oferts/wizard_form_ofert.json');
const language = $('body').data("language");

$.fn.datepicker.dates['es'] = {
  days: getTranslationValue(config, [language, "datepicker", "days"], ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"]),
  daysShort: getTranslationValue(config, [language, "datepicker", "daysShort"],["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"]),
  daysMin: getTranslationValue(config, [language, "datepicker", "daysMin"],["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"]),
  months: getTranslationValue(config, [language, "datepicker", "months"],["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]),
  monthsShort: getTranslationValue(config, [language, "datepicker", "monthsShort"],["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]),
  today: getTranslationValue(config, [language, "datepicker", "today"],"Hoy"),
  clear: getTranslationValue(config, [language, "datepicker", "clear"],"Limpiar"),
  format: "mm/dd/yyyy",
  titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
  weekStart: 0
};

// Class definition
var KTWizardOfert = function () {
	// Base elements
	var _wizardEl;
	//var _formEl;
	var _wizard;
	//var _validations = [];

	// Private functions
	var initWizard = function () {
		var urlParams = new URLSearchParams(window.location.search);
		var getIdParam = urlParams.get('id');
		var isNew = $(".new-ofert-container").length > 0 && !getIdParam ? true : false;
    var isExternal = urlParams.get('external') === 'true';
		var filterQuestionMenuStep = $("#menu-ofert-step-2");
		var killerQuestionMenuStep = $("#menu-ofert-step-6");

		if(getIdParam){
			$('.wizard-step').css("cursor", "pointer")
		}

		if (!isNew) {
			var offerExternalLink = checkExternalForm();
			if (offerExternalLink.length > 0) {
				hide_filter_questions_step();
				hide_killer_questions_step();
			}
		}

		// Initialize form wizard
		_wizard = new KTWizard(_wizardEl, {
			startStep: 1, // initial active step number
			clickableSteps: (isNew ? false : true) // to make steps clickable this set value true and add data-wizard-clickable="true" in HTML for class="wizard" element
		});

    if (isExternal) {
			var wizardSteps = $('.wizard-step:not(.hidden)').length;
  		var goToStep = wizardSteps > 0 ? wizardSteps : 5;
      _wizard.goTo(goToStep);
      render_review_form();
    }

		// Validation before going to next page
		_wizard.on('beforeNext', function (wizard) {
			// Don't go to the next step yet
			_wizard.stop();

			// Se obtiene el paso actual
			var currentStep = $('#ofert-form').find('[data-wizard-state="current"]').attr("id");

			switch (currentStep) {
				case "ofert-step-0":
					var errorText = getTranslationValue(config, [language, "KTWizardOfert", "initWizard", "actualStep_0", "errorText"], "Lo sentimos!, hemos detectado algunos errores. Por favor revise los datos ingresados.")
				
					if(!check_step(currentStep, errorText)){
					 	return false;
					}

					handleStepZero(wizard, _wizard);

					break;
				case "ofert-step-1":
					var errorText = getTranslationValue(config, [language, "KTWizardOfert", "initWizard", "actualStep_1", "errorText"], "Lo sentimos!, hemos detectado algunos errores. Por favor revise los datos ingresados.")

					if(!check_step(currentStep, errorText)){
					 	return false;
					 }

					handleStepOne(wizard, _wizard, filterQuestionMenuStep, killerQuestionMenuStep);

          break;
				case "ofert-step-6":
					var errorText = getTranslationValue(config, [language, "KTWizardOfert", "initWizard", "actualStep_2", "else_formOfert_alert_text"],"Lo sentimos!, hemos detectado algunos errores. Por favor revise los datos ingresados.")

					if(!check_step(currentStep, errorText)){
						return false;
					}

					renderAndNextStep(_wizard);

					break;
				case "ofert-step-2":
					var errorText = getTranslationValue(config, [language, "KTWizardOfert", "initWizard", "actualStep_2", "else_formOfert_alert_text"],"Lo sentimos!, hemos detectado algunos errores. Por favor revise los datos ingresados.")

					if(!check_step(currentStep, errorText)){
						return false;
					}

					renderAndNextStep(_wizard);

					break;
				case "ofert-step-3":
					var errorText = getTranslationValue(config, [language, "KTWizardOfert", "initWizard", "actualStep_2", "isChecked_alert_text"],"Debes seleccionar al menos una opción.")

					if(!check_step_for_checkboxs(currentStep, ".category-area-item:checked", errorText)){
						return false;
					}

					renderAndNextStep(_wizard);

					break;
				case "ofert-step-4":
					var errorText = getTranslationValue(config, [language, "KTWizardOfert", "initWizard", "actualStep_2", "isChecked_alert_text"],"Debes seleccionar al menos una opción.")

					if(!check_step_for_checkboxs(currentStep, ".ofert-benefit-item:checked", errorText)){
						return false;
					}

					renderAndNextStep(_wizard);

					break;
				default:
					renderAndNextStep(_wizard);
			}

		});

		// Change event
		_wizard.on('change', function (wizard) {
			KTUtil.scrollTop();
		});
	}

	var renderAndNextStep = function(_wizard){
		updateQuestionCounts(".cont-question-filter", ".count", "count_");
  		updateQuestionCounts(".cont-question-killer", ".count_killer", "count_");
		var count_position = $("#cont-ofert-killer-questions").find("#count_6").length;
		
		if (count_position == 1) {
			Swal.fire({
				title: 'Se permite un maximo de 5 preguntas filtro',
				icon: 'warning',
				allowEscapeKey: false,
				allowEnterKey: false,
				buttonsStyling: false,
				allowOutsideClick: false,
				confirmButtonText: "Entendido",
				showCancelButton: false,
				customClass: {
					confirmButton: "btn btn-fj-purple",
					cancelButton: "btn btn-light"
				}
			})
		} else {
			render_review_form()
			_wizard.goNext();
		}
	}

	function updateQuestionCounts(selector, countClass, countPrefix) {
		$(selector).each(function(index) {
			$(this).find(countClass).text(index + 1);
			$(this).find(countClass).attr("id", countPrefix + (index + 1));
			$(this).find(".hidden_position").val(index);
		});
	}

	var check_step = function(formId, errorText){
		const formOfert = check_inputs_form(formId);

		if(!formOfert){
			error_alert(errorText)
			return false;
		}

		return true
	}

	var check_step_for_checkboxs = function(formId, klassElement, errorText){
		// Revisa si ha sido checkeado algun elemento
		const isChecked = $('#'+formId+' '+klassElement).length;

		// Si no esta chequeado
		if (isChecked == 0) {
			error_alert(errorText)
			return false;
		}

		return true
	}

	var handleStepZero = function(wizard, _wizard) {
		var checkedOfertType = $('#ofert_enum_type input:checked');
		if (checkedOfertType.length < 1) return;

		var isTechQuestionInput = $('#ofert_is_tech');
		if (isTechQuestionInput.length < 1) return;
		
		var isTechContainer = isTechQuestionInput.parent().parent().parent().parent();

		if (isTechContainer.length < 1) return;

		if (checkedOfertType.val() == '3') {
			isTechQuestionInput.prop("checked", false);
			isTechContainer.addClass('disabled d-none');
			hiddeCategoryAreas('professional');
			
		} else {
			if (isTechContainer.length > 0) isTechContainer.removeClass('disabled d-none');
			hiddeCategoryAreas('massive');
		}

		renderAndNextStep(_wizard);
	}

	var hiddeCategoryAreas = function(type) {
		var categoryAreas = $('#ofert_category_areas .checkbox-inline');

		if (categoryAreas.length > 0) {
			categoryAreas.each(function(){
				var categoryArea = $(this);
				if (categoryArea.hasClass(type)) {
					categoryArea.addClass('disabled d-none');
					var categoryAreaInput = categoryArea.find('input');
					if (categoryAreaInput.length > 0) categoryAreaInput.prop('checked', false);
				} else {
					categoryArea.removeClass('disabled d-none');
				}
			})
		}
	}

	var handleStepOne = function(wizard, _wizard, filterQuestionMenuStep, killerQuestionMenuStep) {
		const offerExternalLink = checkExternalForm();
		var clientFromAdmin = $('#kt_wizard_ofert #ofert-form #admin_offer_client');
		var clientFromRecruiter = $('#kt_wizard_ofert #ofert-form #recruiter_client');
		var selectedClient = $('#kt_wizard_ofert #ofert-form #ofert_client');

		let steps;

		if(offerExternalLink.length > 0) {
			const isNewOffer = $(".wizard-new-offer").length > 0 ? true : false;

			if(isNewOffer) {
				showAlertExternalOffer(_wizard, filterQuestionMenuStep, killerQuestionMenuStep);
			} else {
				hide_filter_questions_step()
				hide_killer_questions_step()
				renderAndNextStep(_wizard);
			}
		} else {
			show_filter_questions_step(filterQuestionMenuStep);
			if (!checkAndShowKillerQuestions(clientFromAdmin, killerQuestionMenuStep) && !checkAndShowKillerQuestions(clientFromRecruiter, killerQuestionMenuStep) && selectedClient.length > 0 && selectedClient.find('option:selected').data('has-killer')) {
				show_killer_questions_step(killerQuestionMenuStep);
			}

			renderAndNextStep(_wizard);
		}

		// Obtiene los wizard-step que no tengan la clase hidden y que su data-wizard-type no sea vacio
		var activesSteps = $('.wizard-step:not(.hidden)[data-wizard-type]');
		// Si los largos del wizard y de los pasos activos es distinto, se asigna el largo de los pasos activos a largo del wizard
		if (wizard.steps.length != activesSteps.length) {
			steps = activesSteps.length
		} else {
			steps = wizard.steps.length
		}

		set_total_steps_wizard(wizard, steps)
	}

	function checkAndShowKillerQuestions(clientElement, killerQuestionMenuStep) {
		if (clientElement.length > 0 && clientElement.data('has-killer')) {
		  show_killer_questions_step(killerQuestionMenuStep);
		  return true;
		}
		return false;
	}

	var checkExternalForm = function(){
		return $("#ofert_link_is_external:checked");
	}

	var showAlertExternalOffer = function(_wizard, filterQuestionMenuStep, killerQuestionMenuStep){
		hide_filter_questions_step(true);
		hide_killer_questions_step(true);
		Swal.fire({
			titleText: getTranslationValue(config, [language, "KTWizardOfert", "initWizard", "actualStep_1", "Swalfire_1_titleText"],"Importante"),
			text: getTranslationValue(config, [language, "KTWizardOfert", "initWizard", "actualStep_1", "Swalfire_1_text"],"Al seleccionar cuestionario externo se desactiva la sección de preguntas."),
			icon: "info",
			buttonsStyling: false,
			confirmButtonText: getTranslationValue(config, [language, "KTWizardOfert", "initWizard", "actualStep_1", "Swalfire_1_confirmButtonText"],"Entendido"),
			showCancelButton: true,
			cancelButtonText: getTranslationValue(config, [language, "KTWizardOfert", "initWizard", "actualStep_1", "Swalfire_1_cancelButtonText"],"Cancelar"),
			customClass: {
				confirmButton: "btn btn-fj-orange",
				cancelButton: "btn btn-light"
			}
		}).then(function (result) {
			if (result.isConfirmed) {
				hide_filter_questions_step(true);
				hide_killer_questions_step(true);
				renderAndNextStep(_wizard);
			} else {
				show_filter_questions_step(filterQuestionMenuStep);
				show_killer_questions_step(killerQuestionMenuStep);
			}
		});
	}

	function showStep(menuStepSelector, formStepSelector, menuStepElement, afterElementSelector) {
		let menuStep = $(menuStepSelector);
		
		if (!menuStep || menuStep.length < 1) {
			addStepMenu(menuStepElement, afterElementSelector);
			menuStep = menuStepElement;
		}
		
		menuStep.removeClass("hidden");
		menuStep.attr("data-wizard-type", "step");
		
		const stepForm = $(formStepSelector);
		stepForm.removeClass("hidden");
		stepForm.attr("data-wizard-type", "step-content");
	}
	
	function addStepMenu(stepMenuElement, afterElementSelector) {
		const afterElement = $(afterElementSelector);
		if (!stepMenuElement || !afterElement || afterElement.length < 1) return;
		
		afterElement.after(stepMenuElement);
	}
	
	function hideStep(menuStepSelector, formStepSelector, containerSelector, isNewOffer = false) {
		const menuStep = $(menuStepSelector);
		
		if (menuStep && menuStep.length > 0) {
			menuStep.addClass("hidden");
			menuStep.attr("data-wizard-type", "");
			if (!isNewOffer) menuStep.detach();
		}
		
		const stepForm = $(formStepSelector);
		stepForm.addClass("hidden");
		stepForm.attr("data-wizard-type", "");
		
		$(containerSelector).html(null);
	}
	
	var show_filter_questions_step = function(filterQuestionMenuStep) {
		showStep("#menu-ofert-step-2", "#ofert-form #ofert-step-2", filterQuestionMenuStep, "#menu-ofert-step-1");
	}
	
	var show_killer_questions_step = function(killerQuestionMenuStep) {
		showStep("#menu-ofert-step-6", "#ofert-form #ofert-step-6", killerQuestionMenuStep, "#menu-ofert-step-1");
	}
	
	var hide_filter_questions_step = function(isNewOffer = false) {
		hideStep("#menu-ofert-step-2", "#ofert-form #ofert-step-2", "#cont-ofert-questions", isNewOffer);
	}
	
	var hide_killer_questions_step = function(isNewOffer = false) {
		hideStep("#menu-ofert-step-6", "#ofert-form #ofert-step-6", "#cont-ofert-killer-questions", isNewOffer);
	}

	var set_total_steps_wizard = function(wizard, steps){
		wizard.totalSteps = steps
	}

	var check_inputs_form = function (form) {
		$(".trix-input.trix-input--dialog").addClass("optional")
		$(".trix-button.trix-button--dialog").addClass("optional")

		var error = 0;
		var container = $('#'+form+'');
		var inputs = container.find($("input").not(".optional"));
		var selects = container.find($("select").not(".optional"));
		var textareas = container.find($("textarea").not(".optional"));

		const errorMsgText = getTranslationValue(config, [language, "KTWizardOfert", "check_inputs_form", "errorMsgText"], "Debes completar este campo.");
		const errorWithoutOptionsText = getTranslationValue(config, [language, "KTWizardOfert", "check_inputs_form", "errorWithoutOptionsText"], "Debes agregar al menos una opción.");

		var errorMsg = '<div class="fv-plugins-message-container"><div class="fv-help-block">'+errorMsgText+'</div></div>';
		var errorWithoutOptions = '<div class="fv-plugins-message-container"><div class="fv-help-block">'+errorWithoutOptionsText+'</div></div>';

		inputs.each(function() {
			var inputName = $(this).attr('name');
			var inputType = $(this).attr('type');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "" && typeof inputName != "undefined") {
				if (inputType == "radio" || inputType == "checkbox") {
					inputName = $(this).attr('name');
					// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
					contInput = $(this).parent().parent();
					// Validamos si este input esta dentro de un checkbox list
					if(contInput.hasClass("checkbox-list")){
						// Cambia el contInput
						contInput = $(this).parent().parent().parent();
					}

					// Se busca el mensaje de error y lo elimina
					contInput.find(".fv-plugins-message-container").remove()
					// Revisa si esta activada la opcion
					var isChecked = $('input[name="'+ inputName +'"]:checked').length;
					// Si no esta chequeado
					if (isChecked == 0) {
						// Se muestra el mensaje de error
						contInput.append(errorMsg);
						// Le suma al contador de errores
						error++;
					} else {
						contInput.find(".fv-plugins-message-container").remove()
					}
				} else if (inputType == "email") {
					const emailRegex = /\b[\w+\-.]+@[a-z\d\-.]+\.[a-z]+\b/;
					// Remueve el icono de alerta o success del input
					$(this).removeClass("is-invalid");
					$(this).removeClass("is-valid");
					// Remueve la clase de has-danger y has-success al contenedor del input
					contInput.removeClass("has-danger");
					contInput.removeClass("has-success");
					// Se busca el mensaje de error y lo elimina
					contInput.find(".fv-plugins-message-container").remove()
					// Si el input esta vacio
					const emailVal = $(this).val();
					if (!emailVal || !emailRegex.test(emailVal)) {
						// Agrega el icono al input
						$(this).addClass("is-invalid");
						// Agrega la clase de has-danger al contenedor del input
						contInput.addClass("has-danger");
						// Se muestra el mensaje de error
						contInput.append(errorMsg);
						// Le suma al contador de errores
						error++;
					} else {
						// Agrega el icono al input
						$(this).addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.addClass("has-success");
					}
				} else if (inputType == "text" || inputType == "date" || inputType == "number" || inputType == "hidden" || inputType == "search") {
					// Si es un campo hidden obligatorio es porque es un typeahead o un trix
					if (inputType == "hidden") {
						// Chequeamos si el input hidden es un trix textarea
						var inputTrix = $(this).hasClass('trix-input');
						// Si el inputTrix existe
						if(inputTrix) {
							// Sobre escribe el contInput con el elemento que corresponde
							// Con un solo parent() llegamos al padre del contenedor de la pregunta con trix
							contInput = $(this).parent();
							// Remueve el icono de alerta o success del input
							contInput.removeClass("is-invalid");
							contInput.removeClass("is-valid");
							// Se busca el mensaje de error y lo elimina
							contInput.find(".fv-plugins-message-container").remove()
						// De lo contrario es un campo del typeahead
						} else {
							// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
							contInput = $(this).parent().parent();
							// Remueve el icono de alerta o success del input
							contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-invalid");
							contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-valid");
							// Se busca el mensaje de error y lo elimina
							contInput.find(".fv-plugins-icon-container").find(".fv-plugins-message-container").remove()
						}
						// Remueve la clase has-danger o has-success del contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Si el input esta vacio
						if (!$(this).val()) {
							// Si el inputTrix existe
							if(inputTrix) {
								// Agrega el icono al input
								contInput.find("trix-editor").addClass("is-invalid");
								// Agrega la clase de has-danger al contenedor del input
								contInput.addClass("has-danger");
								// Se muestra el mensaje de error
								contInput.append(errorMsg);
							// De lo contrario es un campo del typeahead
							} else {
								// Agrega el icono al input
								contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").addClass("is-invalid");
								// Agrega la clase de has-danger al contenedor del input
								contInput.find(".fv-plugins-icon-container").addClass("has-danger");
								// Se muestra el mensaje de error
								contInput.find(".fv-plugins-icon-container").append(errorMsg);
							}

							// Le suma al contador de errores
							error++;
						// Si el input esta correcto
						} else {
							// Si el inputTrix existe
							if(inputTrix) {
								// Agrega el icono al input
								contInput.find("trix-editor").addClass("is-valid");
								// Agrega la clase de has-danger al contenedor del input
								contInput.addClass("has-success");
							// De lo contrario es un campo del typeahead
							} else {
								// Agrega el icono al input
								contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").addClass("is-valid");
								// Agrega la clase de has-danger al contenedor del input
								contInput.find(".fv-plugins-icon-container").addClass("has-success");
							}
						}
					// Si son inputs normales
					} else {
						// Remueve el icono de alerta o success del input
						$(this).removeClass("is-invalid");
						$(this).removeClass("is-valid");
						// Remueve la clase de has-danger y has-success al contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Se busca el mensaje de error y lo elimina
						contInput.find(".fv-plugins-message-container").remove()
						// Si el input esta vacio
						if (!$(this).val()) {
							// Agrega el icono al input
							$(this).addClass("is-invalid");
							// Agrega la clase de has-danger al contenedor del input
							contInput.addClass("has-danger");
							// Se muestra el mensaje de error
							contInput.append(errorMsg);
							// Le suma al contador de errores
							error++;
						} else {
							// Agrega el icono al input
							$(this).addClass("is-valid");
							// Agrega la clase de has-success al contenedor del input
							contInput.addClass("has-success");
						}
					}
				}
			}
		})

		selects.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();
      var isSelectized = $(this).hasClass("selectized");

			if(inputName != null && inputName != "") {
				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Revisamos si el select es multiple
				var hasMultiple = $(this).attr("multiple")
				// Si el input esta vacio
				if ($(this).val().length == 0) {
					// Si es multiple
					if(hasMultiple) {
						// Al input con la clase tt-input le va a agregar la clase form-control para que muestre
						// el icono
						$(this).parent().find(".tt-input").addClass("form-control");
						// Cambia el icono de invalido por valido
						$(this).parent().find(".tt-input").removeClass("is-valid").addClass("is-invalid");
					}

          if(isSelectized) {
            $(this).parent().find(".selectize-control").addClass("is-invalid");
          }

					$(this).addClass("is-invalid");
					contInput.addClass("has-danger");
					contInput.append(errorMsg);
					error++;
				} else {
					// Debemos validar el formulario de preguntas para las preguntas con opciones.
					// Asi que primero detectamos que select es una preguna del formulario
					var hasQuestionSelect = $(this).hasClass("filter_question_enum_type")
					// Si es un select del formulario de preguntas
					if(hasQuestionSelect) {
						// Si la pregunta es de los tipo con opciones
						if ($(this).val() == "2" || $(this).val() == "3" || $(this).val() == "4") {
							// Obtiene las opciones que hay
							var optionsQuestion = $(this).parent().parent().parent().find(".cont-option-question-filter").children()
							// Si hay opciones se valida correctamente
							if(optionsQuestion.length > 0){
								// Agrega el icono al input
								$(this).addClass("is-valid");
								// Agrega la clase de has-success al contenedor del input
								contInput.addClass("has-success");
							// Si no tiene opciones
							} else {
								$(this).addClass("is-invalid");
								contInput.addClass("has-danger");
								contInput.append(errorWithoutOptions);
								error++;
							}
						// Si la pregunta es de un tipo texto
						} else {
							// Agrega el icono al input
							$(this).addClass("is-valid");
							// Agrega la clase de has-success al contenedor del input
							contInput.addClass("has-success");
						}

					// De lo contrario es un select normal y se valida correctamente
					} else {
						// Si es multiple
						if(hasMultiple) {
							// Cambia el icono de invalido por valido
							$(this).parent().find(".tt-input").removeClass("is-invalid").addClass("is-valid");
						}

						// Agrega el icono al input
						$(this).removeClass("is-invalid").addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.addClass("has-success");

            if(isSelectized) {
              $(this).parent().find(".selectize-control").removeClass("is-invalid").addClass("is-valid");
            }

					}
				}
			}
		})

		textareas.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "") {
				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Si el input esta vacio
				if (!$(this).val()) {
					// Agrega el icono al input
					$(this).addClass("is-invalid");
					// Agrega la clase de has-danger al contenedor del input
					contInput.addClass("has-danger");
					// Muestra el mensaje de error
					contInput.append(errorMsg);
					error++;
				} else {
					// Agrega el icono al input
					$(this).addClass("is-valid");
					// Agrega la clase de has-success al contenedor del input
					contInput.addClass("has-success");
				}
			}
		})

		// Se coloca el simbolo de ok a los campos que no son obligatorios
		var inputsNotOptional = container.find($("input.optional"));
		var selectsNotOptional = container.find($("select.optional"));
		var textareasNotOptional = container.find($("textarea.optional"));

		inputsNotOptional.each(function() {
			var inputName = $(this).attr('name');
			var inputType = $(this).attr('type');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "") {
				if (inputType == "text" || inputType == "date" || inputType == "number" || inputType == "hidden") {
					// Si es un campo hidden obligatorio es porque es un typeahead
					if (inputType == "hidden") {
						// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
						contInput = $(this).parent().parent();
						// Remueve el icono de alerta o success del input
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-invalid");
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-valid");
						// Se busca el mensaje de error y lo elimina
						contInput.find(".fv-plugins-icon-container").find(".fv-plugins-message-container").remove()
						// Remueve la clase has-danger o has-success del contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Agrega el icono al input
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.find(".fv-plugins-icon-container").addClass("has-success");
					// Si son inputs normales
					} else {
						// Remueve el icono de alerta o success del input
						$(this).removeClass("is-invalid");
						$(this).removeClass("is-valid");
						// Remueve la clase de has-danger y has-success al contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Se busca el mensaje de error y lo elimina
						contInput.find(".fv-plugins-message-container").remove()
						// Agrega el icono al input
						$(this).addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.addClass("has-success");
					}
				} else if (inputType == "checkbox") {
					// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
					contInput = $(this).parent().parent();
					// Se busca el mensaje de error y lo elimina
					contInput.find(".fv-plugins-message-container").remove()
				}
			}
		})

		selectsNotOptional.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "") {
				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Agrega el icono al input
				$(this).addClass("is-valid");
				// Agrega la clase de has-success al contenedor del input
				contInput.addClass("has-success");
			}
		})

		textareasNotOptional.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "") {
				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Agrega el icono al input
				$(this).addClass("is-valid");
				// Agrega la clase de has-success al contenedor del input
				contInput.addClass("has-success");
			}
		})

		return error == 0 ? true : false;
	}

	var render_review_form = function() {
		// Esto es del primer paso del wizard
		// Asigna la infromacion a las variables
		const variableValues = getTranslationValue(config, [language, "KTWizardOfert", "render_review_form", "variables"],{affirmative: "Si", negative: "No", not_specified: "No especifica"})

		var bannerOffer = $("#ofert-form #cont_form_offer_banner .image-input-wrapper")
		var isConfidential = $("#ofert-form #ofert_is_confidential:checked").length > 0 ? variableValues["affirmative"] : variableValues["negative"]
		var isTech = $("#ofert-form #ofert_is_tech:checked").length > 0 ? variableValues["affirmative"] : variableValues["negative"]
		var title = $("#ofert-form #ofert_title").val()
		var info = $.parseHTML($("#ofert-form #ofert_info").val())
		var benefits = $.parseHTML($("#ofert-form #ofert_benefits").val()) == "" ? variableValues["not_specified"] : $.parseHTML($("#ofert-form #ofert_benefits").val())
		var startDate = $("#ofert-form #ofert_start_date").val() == "" ? variableValues["not_specified"] : $("#ofert-form #ofert_start_date").val()
		var endDate = $("#ofert-form #ofert_end_date").val() == "" ? variableValues["not_specified"] : $("#ofert-form #ofert_end_date").val()
		var address = $("#ofert-form #ofert_address").val() == "" ? variableValues["not_specified"] : $("#ofert-form #ofert_address").val()
    var rangeSalary = $("#ofert-form #ofert_range_salary").val();
		var salaryShow = $("#ofert-form #ofert_show_salary:checked").length > 0 ? variableValues["affirmative"] : variableValues["negative"]
		var isInternational = $("#ofert-form #ofert_is_international:checked").length > 0 ? variableValues["affirmative"] : variableValues["negative"]
		var isExternal = $("#ofert-form #ofert_link_is_external:checked").length > 0 ? variableValues["affirmative"] : variableValues["negative"]
		var urlExternal = $("#ofert-form #ofert_link_url").val()
		var emailNotification = $("#ofert-form #ofert_email_notification").val()
		var orderScoreProfile = $("#ofert-form #ofert_order_score_profile option:selected").val() == "" ? variableValues["negative"] : $("#ofert-form #ofert_order_score_profile option:selected").text()

		var selectedCountries = $("#ofert-form #ofert_country_id option:selected")
		var selectedCountriesText = selectedCountries.length == 1 ? selectedCountries.text() : selectedCountries.map(function() { return $(this).text() }).get().join( ", " );
		
		var stepZeroOfertType = $("#ofert-form #ofert_enum_type input:checked")
		var type = stepZeroOfertType.length > 0 ? stepZeroOfertType.parent().parent().parent().find('span.option-title').text() : $("#ofert-form #ofert_enum_type option:selected").text()

		// Modalidad
		var workplaces = $("#ofert-form .ofert_workplaces:checked")

		var listWorkplaces = ""
		workplaces.each(function(i, w) {
			// Se revisa si la modalidad/workplace actual es del tipo Remoto Local
			var outputRemoteCountries = ""
			// Si el workplace es presencial
			if($(w).val() == "0"){
				var presencialCountries = $("#ofert-form #ofert_country option:selected")

				var listPresencialCountries = ""
				presencialCountries.each(function(i, c) {
					// Se obtiene el texto del label
					var countryName = $(c).text()
					// Se limpian los espacios del string
					countryName = $.trim(countryName)
					// Se asigna el elemento a renderear
					var outputList = "<li>"+countryName+"</li>";
					// Se agrega el nuevo elemento en el listado
					listPresencialCountries = listPresencialCountries + outputList
				})

				outputRemoteCountries = ': <ul class="child-list mb-3">'+listPresencialCountries+'</ul>';
			// Si el workplace es remoto local
			} else if($(w).val() == "3"){
				var remoteCountries = $("#ofert-form #ofert_remote_country option:selected")

				var listRemoteCountries = ""
				remoteCountries.each(function(i, c) {
					// Se obtiene el texto del label
					var countryName = $(c).text()
					// Se limpian los espacios del string
					countryName = $.trim(countryName)
					// Se asigna el elemento a renderear
					var outputList = "<li>"+countryName+"</li>";
					// Se agrega el nuevo elemento en el listado
					listRemoteCountries = listRemoteCountries + outputList
				})

				outputRemoteCountries = ': <ul class="child-list">'+listRemoteCountries+'</ul>';
			}

			// Se obtiene el texto del label
			var workplace = $(w).parent().text()
			// Se limpian los espacios del string
			workplace = $.trim(workplace)
			// Se asigna el elemento a renderear
			var outputList = "<li>"+workplace+""+outputRemoteCountries+"</li>";
			// Se agrega el nuevo elemento en el listado
			listWorkplaces = listWorkplaces + outputList
		})

		var outputWorkplaces = '<div class="cont-pointer-options"><ul>'+listWorkplaces+'</ul></div>';

		// Reemplaza la información que existan en los elementos por el de la variable
		if(bannerOffer.length > 0){
			$("#ofert-form #item_banner .image-input-wrapper").attr("style", bannerOffer.attr("style"))
		}

		$("#ofert-form #item_is_confidential span").text(isConfidential)
		$("#ofert-form #item_is_tech span").text(isTech)
		$("#ofert-form #item_title span").text(title)
		$("#ofert-form #item_info span").html(info)
		$("#ofert-form #item_benefits span").html(benefits)
		$("#ofert-form #item_start_date span").text(startDate)
		$("#ofert-form #item_end_date span").text(endDate)
		$("#ofert-form #item_address span").text(address)
		$("#ofert-form #item_country_id span").text(selectedCountriesText)
		// $("#ofert-form #item_city span").text(city)
		$("#ofert-form #item_salary span").text(rangeSalary)
		$("#ofert-form #item_salary_show span").text(salaryShow)
		$("#ofert-form #item_enum_type span").text(type)
		$("#ofert-form #item_type_place_job span").html(outputWorkplaces)
		$("#ofert-form #item_is_international span").html(isInternational)
		$("#ofert-form #item_is_external span").text( isExternal == "Si" ? urlExternal : "No" )
		$("#ofert-form #item_email_notification span").text(emailNotification)
		$("#ofert-form #item_score_profile span").text(orderScoreProfile)

		// Se limpia el listado de preguntas
		$("#ofert-form .cont-review-killer-questions").html('');

		var killerQuestions = $("#cont-ofert-killer-questions").children()

		const killerQuestionsText = getTranslationValue(config, [language, "KTWizardOfert", "render_review_form", "killer_questions_text"],{q: "Pregunta ", ca: "Respuesta Correcta:", description: "Descripción"})

		killerQuestions.each(function(i, q) {
			var labelQuestion = $(q).find(".cont-label .killer_question_label").val()
			var correctAnswerQuestion = $(q).find(".cont-label .killer_question_is_required").val() == "0" ? variableValues["negative"] : variableValues["affirmative"]
			var hintQuestion = $(q).find(".cont-label .killer_question_hint").val()

			var output = '<div class="row container"><strong class="col-sm-3">'+killerQuestionsText["q"]+ (parseInt(i)+1) +'</strong><span class="col-sm-6">'+labelQuestion+'</span></div><div class="row container"><strong class="col-sm-3">'+killerQuestionsText["ca"]+'</strong><span class="col-sm-6">'+correctAnswerQuestion+'</span></div><div class="row container"><strong class="col-sm-3">'+killerQuestionsText["description"]+'</strong><span class="col-sm-6">'+hintQuestion+'</span></div></div>';

			var contOutput = '<div class="cont-list-output">'+output+'</div>'

			$("#ofert-form .cont-review-killer-questions").append(contOutput)
		});

		// Si no hay preguntas killer
		const killerQuestionLengthHtml = getTranslationValue(config, [language, "KTWizardOfert", "render_review_form", "question_length_html"],"Esta oferta no contiene preguntas killer")
		if(killerQuestions.length == 0){
			// Se limpia el listado de preguntas
			$("#ofert-form .cont-review-killer-questions").html(killerQuestionLengthHtml);
		} else {
			if(isExternal == variableValues["affirmative"]) {
				$("#ofert-form .cont-review-killer-questions").html(killerQuestionLengthHtml);
			}
		}

		// Se limpia el listado de preguntas
		$("#ofert-form .cont-review-questions").html('');
		// Se obtienen las preguntas
		var questions = $("#cont-ofert-questions").children()
		const questionsText = getTranslationValue(config, [language, "KTWizardOfert", "render_review_form", "questions_text"],{q: "Pregunta ", rf: "¿Campo Obligatorio?:", qt: "Tipo de Pregunta:", description: "Descripción", op: "Opciones:"})

		questions.each(function(i, q) {
			var typeQuestion = $(q).find(".cont-label .filter_question_enum_type option:selected").text()
			var labelQuestion = $(q).find(".cont-label .filter_question_label").val()
			var isRequiredQuestion = $(q).find(".cont-label .filter_question_is_required").val() == "0" ? variableValues["negative"] : variableValues["affirmative"]
			var hintQuestion = $(q).find(".cont-label .filter_question_hint").val()
			var options = $(q).find(".cont-option-question-filter").children()

			if(options.length > 0){
				var listOptions = ""
				options.each(function(j, o) {
					var labelOption = $(o).find("input").val()
					var outputList = "<li>"+labelOption+"</li>";
					listOptions = listOptions + outputList
				});

				var output = '<div class="row container"><strong class="col-sm-3">'+questionsText["q"]+ (parseInt(i)+1) +':</strong><span class="col-sm-6">'+labelQuestion+'</span></div><div class="row container"><strong class="col-sm-3">'+questionsText["rf"]+'</strong><span class="col-sm-6">'+isRequiredQuestion+'</span></div><div class="row container"><strong class="col-sm-3">'+questionsText["qt"]+'</strong><span class="col-sm-6">'+typeQuestion+'</span></div><div class="row container"><strong class="col-sm-3">'+questionsText["description"]+'</strong><span class="col-sm-6">'+hintQuestion+'</span></div><div class="row container cont-review-options"><strong class="col-sm-3">'+questionsText["op"]+'</strong><div class="col-sm-6"><ul>'+listOptions+'</ul></div></div></div>';

			} else {
				var output = '<div class="row container"><strong class="col-sm-3">'+questionsText["q"]+ (parseInt(i)+1) +'</strong><span class="col-sm-6">'+labelQuestion+'</span></div><div class="row container"><strong class="col-sm-3">'+questionsText["rf"]+'</strong><span class="col-sm-6">'+isRequiredQuestion+'</span></div><div class="row container"><strong class="col-sm-3">'+questionsText["qt"]+'</strong><span class="col-sm-6">'+typeQuestion+'</span></div><div class="row container"><strong class="col-sm-3">'+questionsText["description"]+'</strong><span class="col-sm-6">'+hintQuestion+'</span></div></div>';
			}

			var contOutput = '<div class="cont-list-output">'+output+'</div>'

			$("#ofert-form .cont-review-questions").append(contOutput)
		});

		// Si no hay preguntas
		const questionLengthHtml = getTranslationValue(config, [language, "KTWizardOfert", "render_review_form", "question_length_html"],"Esta oferta no contiene preguntas")
		if(questions.length == 0){
			// Se limpia el listado de preguntas
			$("#ofert-form .cont-review-questions").html(questionLengthHtml);
		} else {
			if(isExternal == variableValues["affirmative"]) {
				$("#ofert-form .cont-review-questions").html(questionLengthHtml);
			}
		}

		// Se limpia el listado de areas
		$("#ofert-form .cont-areas-questions").html('');
		// Revisa si ha sido checkeado algun elemento
		var areasSelected = $('#ofert-step-3 .category-area-item:checked');
		if (areasSelected.length > 0) {
			var listAreas = ""
			$.each(areasSelected, function(i, area) {
				// Se obtiene el texto del label
				var areaName = $(area).parent().text()
				// Se limpian los espacios del string
				areaName = $.trim(areaName)
				// Se asigna el elemento a renderear
				var outputList = "<li>"+areaName+"</li>";
				// Se agrega el nuevo elemento en el listado
				listAreas = listAreas + outputList
			});

			var output = '<div class="row container cont-review-options"><div class="col-sm-12"><ul>'+listAreas+'</ul></div></div></div>';

			$("#ofert-form .cont-areas-questions").append(output)
		}

		if($('#ofert-step-4').length > 0){
			// Se limpia el listado de beneficios
			$("#ofert-form .cont-benefits-questions").html('');
			// Revisa si ha sido checkeado algun elemento
			var benefitsSelected = $('#ofert-step-4 .ofert-benefit-item:checked');
			if (benefitsSelected.length > 0) {
				var listBenefits = ""
				$.each(benefitsSelected, function(i, area) {
					// Se obtiene el texto del label
					var benefit = $(area).parent().text()
					// Se limpian los espacios del string
					benefit = $.trim(benefit)
					// Se asigna el elemento a renderear
					var outputList = "<li>"+benefit+"</li>";
					// Se agrega el nuevo elemento en el listado
					listBenefits = listBenefits + outputList
				});

				var output = '<div class="row container cont-review-options"><div class="col-sm-12"><ul>'+listBenefits+'</ul></div></div></div>';

				$("#ofert-form .cont-benefits-questions").append(output)
			}
		}
	}

	/*****************************
    * VALIDACIONES DE FECHAS
    *
    * - Validaciones de fechas
    * - Mascaras de inputs
    */
   var _validation_date = function() {
		$('input#ofert_salary').mask('099.099.099.099', {reverse: true});

		var startDate = $('input#ofert_start_date');
		var endDate = $('input#ofert_end_date');

		startDate.datepicker({
			todayBtn: "linked",
			startDate: 'today',
			language: 'es',
			format: 'yyyy-mm-dd',
			clearBtn: true,
			todayHighlight: true
		}).on("changeDate", function(e) {
			endDate.datepicker('setStartDate', startDate.val());
			if(endDate.data('days') > 0){
				endDate.datepicker('setEndDate', setEndDate(startDate.val()));
			}
		}).on("hide", function(e) {
			if (!startDate.val()) {
				endDate.datepicker('setStartDate', 'today');
				endDate.datepicker('setEndDate', new Date(new Date().setDate(new Date().getDate() + 60)));
			}
		});

		endDate.datepicker({
			todayBtn: "linked",
			clearBtn: true,
			startDate: 'today',
			language: 'es',
			format: 'yyyy-mm-dd',
			endDate: new Date(new Date().setDate(new Date().getDate() + 60))
		});

		if (startDate.val().length > 0 && endDate.data('days') > 0) {
			endDate.datepicker('setEndDate', setEndDate(startDate.val()));
		}

		// Validando que la fecha de fin sea mayor que la de inicio
		$('input#ofert_start_date').on('changeDate', function(e) {
			if ($('input#ofert_end_date').val() !== ''){
				if ( moment($('input#ofert_end_date').val(),["DD/MM/YYYY"]).isSameOrBefore(e.date)){
					const swalFireTextLess = getTranslationValue(config, [language, "KTWizardOfert", "_validation_date", "swalFireTextLess"],'La fecha de inicio debe ser menor que la fecha de término')
					Swal.fire(swalFireTextLess);
					$('input#ofert_start_date').val('');
				}
			}
		});

		// Validando que la fecha de fin sea mayor que la de inicio
		$('input#ofert_end_date').on('changeDate', function(e) {
			if ($('input#ofert_start_date').val() !== ''){
				if ( moment($('input#ofert_start_date').val(),["DD/MM/YYYY"]).isSameOrAfter(e.date)){
					const swalFireTextGreater = getTranslationValue(config, [language, "KTWizardOfert", "_validation_date", "swalFireTextGreater"],'La fecha de término debe ser mayor que la fecha de inicio')
					Swal.fire(swalFireTextGreater);
					$(this).val('');
				}
			}
		});
	};

	var setEndDate = function(initialDate) {
		var originalDate = new Date(initialDate);
		var newDate = new Date(originalDate);
		var durationOfferDays = parseInt($('input#ofert_end_date').data('days'));
		newDate.setDate(newDate.getDate() + durationOfferDays);
		// Formatear la nueva fecha en el formato deseado (YYYY-MM-DD)
		var newDateString = newDate.toISOString().split('T')[0];
		return newDateString;
	}

	var error_alert = function(msg) {
		Swal.fire({
			text: msg,
			icon: "error",
			buttonsStyling: false,
			confirmButtonText: getTranslationValue(config, [language, "KTWizardOfert", "error_alert_Swalfire_confirmButtonText"],"Aceptar"),
			customClass: {
				confirmButton: "btn btn-fj-purple"
			}
		}).then(function () {
			KTUtil.scrollTop();
		});
	}

	return {
		// public functions
		init: function () {
			_wizardEl = KTUtil.getById('kt_wizard_ofert');
			initWizard();
			_validation_date();
		}
	};
}();

var KTShareImage = function() {
  var share_image;

  var _initKTImage = function() {
    share_image = new KTImageInput('kt_ofert_share_iamge');
	}

	return {
		// public functions
		init: function() {
			_initKTImage();
		}
	};
}();


jQuery(document).ready(function () {
	var AUTH_TOKEN = $('meta[name=csrf-token]').attr('content');
	// Se obtiene el campo kt_wizard_ofert
  var wizardOfert = $('#kt_wizard_ofert')

	//var shareImage = $('#kt_ofert_share_iamge')
	// Si existe el campo
	if (wizardOfert.length > 0) {
		KTWizardOfert.init();
  }

	$("#cont-ofert-questions, #cont-ofert-killer-questions").sortable({
		opacity: 0.6,
		cursor: 'grabbing',
		placeholder: 'ui-sortable-placeholder',
		start: function(e, ui){
			ui.placeholder.height(ui.item.height());
		},
		update: function(event, ui) {
			updateQuestionCounts(".cont-question-filter", ".count", "count_");
  			updateQuestionCounts(".cont-question-killer", ".count_killer", "count_");
		}
  	});

	function updateQuestionCounts(selector, countClass, countPrefix) {
		$(selector).each(function(index) {
			$(this).find(countClass).text(index + 1);
			$(this).find(countClass).attr("id", countPrefix + (index + 1));
			$(this).find(".hidden_position").val(index);
		});
	}

	var checkboxes = {
        present: $('input.ofert_workplaces[value="0"]'),
        remote: $('input.ofert_workplaces[value="4"]'),
        hybrid: $('input.ofert_workplaces[value="5"]')
    };
    var countrySelect = $('#ofert_country_id');
    var clientCountryIds = countrySelect.data("client-country-ids");
    var selectize = countrySelect[0].selectize;
    var originalOptions = Object.values(selectize.options).map(option => ({
        value: option.value,
        text: option.text
    }));
	var countriesWithSelectizePosition = countrySelect.data("featured-country-ids")
    
    function sortOptions(options, priorityList) {
        return options.sort((a, b) => {
            var indexA = priorityList.indexOf(a.value);
            var indexB = priorityList.indexOf(b.value);
            return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
        });
    }
    
    originalOptions = sortOptions(originalOptions, countriesWithSelectizePosition);
    
    function toggleSelectize(enable) {
        selectize[enable ? 'enable' : 'disable']();
        countrySelect.prop('disabled', !enable).toggleClass('disabled', !enable);
        var selectizeWrapper = countrySelect.next('.selectize-control');
        selectizeWrapper.toggleClass('disabled', !enable);
        selectizeWrapper.find('.selectize-dropdown').toggleClass('disabled', !enable);
    }
    
    function updateCountrySelectState() {
        toggleSelectize(Object.values(checkboxes).some(cb => cb.is(':checked')));
    }
    
    function handleModalityChange() {
		var isFiltered = checkboxes.present.is(':checked') || checkboxes.hybrid.is(':checked');
	
		// Guardar los valores seleccionados antes de limpiar
		var selectedValues = selectize.getValue(); 
	
		selectize.clear();
		selectize.clearOptions();
	
		var optionsToAdd = isFiltered 
			? originalOptions.filter(option => clientCountryIds.includes(parseInt(option.value)))
			: originalOptions;
	
		optionsToAdd.forEach(option => selectize.addOption(option));
		selectize.refreshOptions(false);
	
		// Restaurar los valores seleccionados si aún están disponibles
		var validValues = selectedValues.filter(val => optionsToAdd.some(opt => opt.value == val));
		selectize.setValue(validValues);
	}
    
    Object.values(checkboxes).forEach(cb => cb.on("change", function() {
        handleModalityChange();
        updateCountrySelectState();
    }));

	handleModalityChange();
    updateCountrySelectState();
	
	/*
  // Si existe el campo
	if (shareImage.length > 0) {
		KTShareImage.init();
	}*/

	/*************
    * CREAR / EDITAR OFERTA
    *
    * - Logica de activacion de campo ciudad como autocompletar (typeahead)
    * - Validacion y ejecución del formulario
    */

	/**
	 * Sort the options of the target select list
	 * alphabetically by label. For some reason, when
	 * we call detach(), the returned options have no
	 * text() and instead we're forced to get the option's
	 * label via the 'label' attribute.
	 * @param select jQuery selector
	 */
	function sort_multi_select(select) {
		var options = select.find('option');
		options.detach().sort(function (a, b) {
			var at = parseInt($(a).attr('data-order')), //label, not text()
				bt = parseInt($(b).attr('data-order'));
			return at > bt ? 1 : at < bt ? -1 : 0;
		});

		options.appendTo(select);

		select.find('option[selected="selected"]').prop('selected',true);
	}

	if($("#kt_wizard_ofert").length > 0){
		// Ordena el selector de moneda
		sort_multi_select($('#kt_wizard_ofert #ofert-form #ofert_currency'));
	}

	$("#kt_wizard_ofert #ofert-form #add-question").on("click", function(){
    var count = $(".cont-question-filter").length;
		const textElements = getTranslationValue(config, [language, "jQuery_document_function", "on_click_add_question"],
			{
				label_text: "Guardar en preguntas frecuentes",
				label_2_text: "Pregunta ",
				span_text: "Obligatorio | Ingrese el título de su pregunta",
				is_required_text: "¿Campo Obligatorio?",
				default_option_value: "Seleccione una opción...",
				affirmative: "Si",
				negative: "No",
				mandatory_text: "Obligatorio",
				question_type_label: "Tipo de Pregunta",
				question_type_option: ["Respuesta Breve", "Párrafo", "Lista Desplegable", "Casillas de Verificación", "Opción Múltiple"],
				hint_label: "Ingrese una explicación breve si es necesario"
			}
		)

		var randomCount = Math.floor(Math.random() * 10000000);

		var output = '<div class="row cont-question-filter ui-sortable-handle">\
				<input type="hidden" class="hidden_position" name="filter_question[n_'+ randomCount +'][position]" value="'+(count)+'" />\
        <div class="col-xl-12 cont-label">\
          <div class="form-group fv-plugins-icon-container">\
            <label>'+textElements["label_text"]+'</label>\
            <label class="checkbox checkbox-sandbox">\
              <input type="checkbox" class="optional" id="filter_question_is_sandbox_'+ randomCount +'" name="filter_question[n_'+ randomCount +'][is_sandbox]" value="" />\
              <span></span>\
            </label>\
          </div>\
        </div>\
				<div class="col-xl-6 cont-label">\
					<div class="form-group">\
					<label>'+textElements["label_2_text"]+'<span class="count" id="count_'+ (count+1) +'">' +(count+1)+'</span></label>\
					<input type="text" class="filter_question_label form-control form-control-solid form-control-lg" name="filter_question[n_'+ randomCount +'][label]" value="" />\
					<span class="form-text text-muted">'+textElements['span_text']+'</span>\
				</div>\
			</div>\
			<div class="col-xl-6 cont-label">\
				<div class="form-group">\
					<label>'+textElements['is_required_text']+'</label>\
					<select id="filter_question_is_required_'+ randomCount +'" data-id="n_'+ randomCount +'" class="filter_question_is_required form-control form-control-lg form-control-solid" data-count="'+ randomCount +'" name="filter_question[n_'+ randomCount +'][is_required]">\
						<option value="">'+textElements['default_option_value']+'</option>\
						<option value="1">'+textElements['affirmative']+'</option>\
						<option value="0">'+textElements['negative']+'</option>\
					</select>\
					<span class="form-text text-muted">'+textElements['mandatory_text']+'</span>\
				</div>\
			</div>\
			<div class="col-xl-6 cont-label">\
				<div class="form-group">\
					<label>'+textElements['question_type_label']+'</label>\
					<select id="filter_question_enum_type_'+ randomCount +'" data-id="n_'+ randomCount +'" class="filter_question_enum_type form-control form-control-lg form-control-solid" data-count="'+ randomCount +'" name="filter_question[n_'+ randomCount +'][enum_type]">\
						<option value="">'+textElements['default_option_value']+'</option>\
						<option value="0">'+textElements['question_type_option'][0]+'</option>\
						<option value="1">'+textElements['question_type_option'][1]+'</option>\
						<option value="2">'+textElements['question_type_option'][2]+'</option>\
						<option value="3">'+textElements['question_type_option'][3]+'</option>\
						<option value="4">'+textElements['question_type_option'][4]+'</option>\
					</select>\
					<span class="form-text text-muted">'+textElements['mandatory_text']+'</span>\
				</div>\
			</div>\
			<div class="col-xl-6 cont-label">\
				<div class="form-group">\
				<label>Descripción</label>\
				<input type="text" class="filter_question_hint form-control form-control-solid form-control-lg optional" name="filter_question[n_'+ randomCount +'][hint]" value="" />\
				<span class="form-text text-muted">'+textElements['hint_label']+'</span>\
				</div>\
			</div>\
			<button class="delete-option"><i class="fas fa-times"></i></button>\
		</div>';

		//countListQuestions++;

		$("#kt_wizard_ofert #ofert-form #cont-ofert-questions").append(output);

		updateQuestionCounts(".cont-question-filter", ".count", "count_");
	})
	
	$("#kt_wizard_ofert #ofert-form #add-killer-question").on("click", function(){
		var count = $(".cont-question-killer").length;
		var count_position = $("#cont-ofert-killer-questions").find("#count_5").length;
		
		if (count_position == 1) {
			Swal.fire({
				title: 'Solo puedes agregar 5 preguntas filtro',
				icon: 'warning',
				allowEscapeKey: false,
				allowEnterKey: false,
				buttonsStyling: false,
				allowOutsideClick: false,
				confirmButtonText: "Entendido",
				showCancelButton: false,
				customClass: {
					confirmButton: "btn btn-fj-purple",
					cancelButton: "btn btn-light"
				}
			})
		} else{
			const textElements = getTranslationValue(config, [language, "jQuery_document_function", "on_click_add_question"],
				{
					label_text: "Guardar en preguntas frecuentes",
					label_2_text: "Pregunta ",
					span_text: "Obligatorio | Ingrese el título de su pregunta",
					correct_answer: "Respuesta Correcta",
					default_option_value: "Seleccione una opción...",
					affirmative: "Sí",
					negative: "No",
					mandatory_text: "Obligatorio",
					hint_label: "Ingrese una explicación breve si es necesario"
				}
			)

			var randomCount = Math.floor(Math.random() * 10000000);

			var output = '<div class="row cont-question-killer ui-sortable-handle">\
					<input type="hidden" class="hidden_position" name="filter_question[n_'+ randomCount +'][position]" value="'+(count)+'" />\
			<div class="col-xl-12 cont-label">\
				<div class="form-group fv-plugins-icon-container">\
				<label>'+textElements["label_text"]+'</label>\
				<label class="checkbox checkbox-sandbox">\
					<input type="checkbox" class="optional" id="filter_question_is_sandbox_'+ randomCount +'" name="filter_question[n_'+ randomCount +'][is_sandbox]" value="" />\
					<span></span>\
				</label>\
				</div>\
			</div>\
					<div class="col-xl-12 cont-label">\
						<div class="form-group">\
						<label>'+textElements["label_2_text"]+'<span class="count_killer" id="count_'+ (count+1) +'">' +(count+1)+'</span></label>\
						<input type="text" class="killer_question_label form-control form-control-solid form-control-lg" name="filter_question[n_'+ randomCount +'][label]" value="" />\
						<span class="form-text text-muted">'+textElements['span_text']+'</span>\
					</div>\
				</div>\
				<div class="col-xl-6 cont-label">\
					<div class="form-group">\
						<label>'+textElements['correct_answer']+'</label>\
						<select id="killer_question_correct_answer_'+ randomCount +'" data-id="n_'+ randomCount +'" class="filter_question_correct_answer form-control form-control-lg form-control-solid" data-count="'+ randomCount +'" name="filter_question[n_'+ randomCount +'][correct_answer]">\
							<option value="">'+textElements['default_option_value']+'</option>\
							<option value="1">'+textElements['affirmative']+'</option>\
							<option value="0">'+textElements['negative']+'</option>\
						</select>\
						<span class="form-text text-muted">'+textElements['mandatory_text']+'</span>\
					</div>\
				</div>\
				<div class="col-xl-6 cont-label">\
					<div class="form-group">\
					<label>Descripción</label>\
					<input type="text" class="killer_question_hint form-control form-control-solid form-control-lg optional" name="filter_question[n_'+ randomCount +'][hint]" value="" />\
					<span class="form-text text-muted">'+textElements['hint_label']+'</span>\
					</div>\
				</div>\
				<button class="delete-option"><i class="fas fa-times"></i></button>\
			</div>';

			$("#kt_wizard_ofert #ofert-form #cont-ofert-killer-questions").append(output);

			updateQuestionCounts(".cont-question-killer", ".count_killer", "count_");
		}
		checkKillerQuestions();
	})

	var killerQuestionMenuStep = $("#menu-ofert-step-6");
	var selectedClient = $('#kt_wizard_ofert #ofert-form #ofert_client');
	if (selectedClient.length > 0){
		validateKillerQuestions(killerQuestionMenuStep);
		validateOrderScore(selectedClient);
	}

	$('#kt_wizard_ofert #ofert-form #ofert_client').on("change" ,function() {
		var selectedClient = $(this);
    	var clientId = selectedClient.val();

		validateKillerQuestions(killerQuestionMenuStep);
		modifyFrequentlyUrls(clientId);
		validateOrderScore(selectedClient);
	});

	function validateOrderScore(selectedClient) {
		var selectedClientHasScoreOrder = selectedClient.find('option:selected').data('has-score');
		if (selectedClientHasScoreOrder){
			show_score_selectize(selectedClient);
		} else {
			hide_score_selectize();
		}
	}

	function show_score_selectize(selectedClient) {
		$(".order-score-profile").removeClass("hidden");
		updateProfiles(selectedClient.val())
	}

	function hide_score_selectize() {
		$(".order-score-profile").addClass("hidden");
	}

	function updateProfiles(clientId) {
		$.ajax({
		  url: '/update_client_profiles_score',  // Ruta para actualizar los perfiles
		  method: 'GET',
		  data: { client_id: clientId },
		  success: function(response) {
			// Actualizar el selector con los nuevos perfiles
			$('#ofert_order_score_profile').empty(); // Vaciar opciones actuales
			$('#ofert_order_score_profile').append('<option value="">' + 'Seleccione una opción...' + '</option>'); // Agregar opción por defecto
			
			// Agregar las nuevas opciones de perfiles
			response.forEach(function(profile) {
			  $('#ofert_order_score_profile').append('<option value="' + profile.id + '">' + profile.name + '</option>');
			});
		  },
		  error: function() {
			console.error('Error al actualizar los perfiles');
		  }
		});
	}

	function modifyFrequentlyUrls(clientID){
		const sandboxQuestionsUrl = "/sandbox_oferts?c="+clientID;
		$("#open_sandbox").attr("href", sandboxQuestionsUrl)

		const sandboxKillerQuestionsUrl = "/sandbox_killer_oferts?c="+clientID;
		$("#open_killer_sandbox").attr("href", sandboxKillerQuestionsUrl)
	}

	function validateKillerQuestions(killerQuestionMenuStep) {
		var selectedClientHasKillerQuestions = $('#kt_wizard_ofert #ofert-form #ofert_client').find('option:selected').data('has-killer');
	  
		if (selectedClientHasKillerQuestions) {
		  show_killer_questions_step(killerQuestionMenuStep);
		  show_review_killer_questions();
		} else {
		  hide_killer_questions_step();
		  hide_review_killer_questions();
		}
	}
	  
	function show_killer_questions_step(killerQuestionMenuStep) {
		let menuStepKillerQuestions = $("#menu-ofert-step-6");
		
		if (!menuStepKillerQuestions || menuStepKillerQuestions.length < 1) {
			addKillerQuestionMenuStep(killerQuestionMenuStep, "#menu-ofert-step-1");
			menuStepKillerQuestions = killerQuestionMenuStep;
		}
		
		menuStepKillerQuestions.removeClass("hidden");
		menuStepKillerQuestions.attr("data-wizard-type", "step");
		
		const stepKillerQuestions = $("#ofert-form #ofert-step-6");
		stepKillerQuestions.removeClass("hidden");
		stepKillerQuestions.attr("data-wizard-type", "step-content");
	}

	function show_review_killer_questions() {
		$(".review-killer-questions").removeClass("hidden");
	}

	function hide_review_killer_questions() {
		$(".review-killer-questions").addClass("hidden");
	}
	
	function addKillerQuestionMenuStep(killerQuestionMenuStep, afterElementSelector) {
		const afterElement = $(afterElementSelector);
		if (!killerQuestionMenuStep || !afterElement || afterElement.length < 1) return;
		
		afterElement.after(killerQuestionMenuStep);
	}
	
	function hide_killer_questions_step(isNewOffer = false) {
		const menuStepKillerQuestions = $("#menu-ofert-step-6");
		
		if (menuStepKillerQuestions && menuStepKillerQuestions.length > 0) {
			menuStepKillerQuestions.addClass("hidden");
			menuStepKillerQuestions.attr("data-wizard-type", "");
			if (!isNewOffer) menuStepKillerQuestions.detach();
		}
		
		const stepKillerQuestions = $("#ofert-form #ofert-step-6");
		stepKillerQuestions.addClass("hidden");
		stepKillerQuestions.attr("data-wizard-type", "");
		
		$("#ofert-form #cont-ofert-killer-questions").html(null);
	}

	function checkKillerQuestions() {
        var count_position = $("#cont-ofert-killer-questions").find("#count_5").length;
		
		if (count_position == 1) {
			$('a#open_killer_sandbox').prop('disabled', true)
			$('a#open_killer_sandbox').addClass('disabled')
		}else {
			$('a#open_killer_sandbox').prop('disabled', false)
			$('a#open_killer_sandbox').removeClass('disabled')
		}
    }

    // Revisa en la pantalla de carga
    checkKillerQuestions();

	// Selecciona el elemento que quieres observar
	var targetNode = document.querySelector('#cont-ofert-killer-questions');
	
	// Verifica si el elemento existe antes de configurar el MutationObserver
    if (targetNode) {
        // Configura las opciones del observador
        var config = { childList: true, subtree: true };

        // Callback que se ejecutará en cada mutación observada
        var callback = function (mutationsList, observer) {
            for (var mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    checkKillerQuestions();
                    break;
                }
            }
        };

        // Crea una instancia del observador con el callback
        var observer = new MutationObserver(callback);

        // Empieza a observar el nodo objetivo con la configuración especificada
        observer.observe(targetNode, config);
    }

	// Elimina una opcion de la pregunta
	$("#kt_wizard_ofert #ofert-form").on("change", ".filter_question_enum_type", function(e){
		var typeQuestion = $(this).val()
		// Elimina el contenedor de opciones de una pregunta
		$(this).parent().parent().parent().find(".cont-option-question-filter").remove()
		$(this).parent().parent().parent().find(".cont-option-add").remove()

		if(typeQuestion == "2" || typeQuestion == "3" || typeQuestion == "4") {
			// filterQuestionId es el valor que tiene el grupo de preguntas dentro del array, es por eso que esta variable va en el name del input, de esta manera agrupamos todos los inputs que correspondan a una pregunta en un solo array y así podemos manipular los datos de forma ordenada.
			// Obtiene el id de la pregunta
			var filterQuestionId = $(this).attr("data-id")
			// Si es un entero es porque ya existe la pregunta y está editando

			const placeHolderText = getTranslationValue(config, [language, "jQuery_document_function", "on_change_filter_question_enum_type", "placeholderText"],"Ingrese el título de su opción")
			if(parseInt(filterQuestionId)){
				var inputOption = '<input type="text" class="form-control form-control-solid form-control-sm" name="filter_question['+ filterQuestionId +'][options][0][]" placeholder="'+placeHolderText+'" value="" />';
			} else {
				var inputOption = '<input type="text" class="form-control form-control-solid form-control-sm" name="filter_question['+ filterQuestionId +'][options][]" placeholder="'+placeHolderText+'" value="" />'
			}

			const btnText = getTranslationValue(config, [language, "jQuery_document_function", "on_change_filter_question_enum_type", "newOptionText"],"Agregar nueva opción")
			var output = 	'<div class="cont-option-question-filter container">\
								<div class="row option-item">\
									<div class="col-xl-6">\
										<div class="form-group">\
											'+inputOption+'\
										</div>\
									</div>\
									<div class="col-xl-6">\
										<div class="form-group">\
											<button class="close-option"><i class="fas fa-times"></i></button>\
										</div>\
									</div>\
								</div>\
							</div>\
							<div class="cont-option-add container mt-5">\
								<div class="row">\
									<div class="col-xl-12">\
										<div class="form-group">\
											<button class="add-option btn btn-sm btn-fj-orange" data-fq-id="'+ filterQuestionId +'">'+btnText+'</button>\
										</div>\
									</div>\
								</div>\
							</div>';

			$(this).parent().parent().parent().find(".cont-option-question-filter").remove()
			$(this).parent().parent().parent().find(".cont-option-add").remove()
			$(this).parent().parent().parent().append(output)
		}
	})

	// Agrega una opcion de una pregunta
	$("#kt_wizard_ofert #ofert-form").on("click", ".add-option", function(e){
		e.preventDefault()
		// Obtiene el id del filter question
		var filterQuestionId = $(this).attr("data-fq-id")
		// Si es un entero es porque ya existe la pregunta y está editando
		const placeHolderText = getTranslationValue(config, [language, "jQuery_document_function", "on_click_add_option_placeholderText"],"Ingrese el título de su opción")
		if(parseInt(filterQuestionId)){
			var inputOption = '<input type="text" class="form-control form-control-solid form-control-sm" name="filter_question['+ filterQuestionId +'][options][0][]" placeholder="'+placeHolderText+'" value="" />';
		} else {
			var inputOption = '<input type="text" class="form-control form-control-solid form-control-sm" name="filter_question['+ filterQuestionId +'][options][]" placeholder="'+placeHolderText+'" value="" />'
		}

		// Base de una opción
		var newOption = '<div class="row option-item">\
							<div class="col-xl-6">\
								'+ inputOption +'\
							</div>\
							<div class="col-xl-6">\
								<div class="form-group">\
									<button class="close-option"><i class="fas fa-times"></i></button>\
								</div>\
							</div>\
						</div>';

		// Se muestra la opción
		$(this).parent().parent().parent().parent().parent().find(".cont-option-question-filter").append(newOption)
	})

	// Elimina una opcion de una pregunta
	$("#kt_wizard_ofert #ofert-form").on("click", ".cont-option-question-filter .close-option", function(e){
		e.preventDefault()
		var el = $(this).parent().parent().parent()
		// Esto se ejecuta si esta en la vista de editar oferta
		var checkIfEditForm = $("#ofert-form.form-edit-ofert").length
		// Si esta en la vista muestra la alerta de que va a eliminar una pregunta
		if(checkIfEditForm > 0){
			// Revisamos si esta opcion se puede archivar
			var isArchived = $(this).hasClass("not-delete")
			// Si la pregunta ya tiene respuestas solo se puede archivar
			if(isArchived) {
				const swalFireValues = getTranslationValue(config, [language, "jQuery_document_function", "on_click_close_option", "Swalfire_1"], {
                    titleText: "Importante",
                    text: "Ésta opción ya tiene respuestas por parte de los postulantes, no podremos eliminarla pero si estará archivada para que no se pierda la información.",
                    confirmButtonText: "Entendido",
                    cancelButtonText: "Cancelar"
                })

				Swal.fire({
					titleText: swalFireValues['titleText'],
					text: swalFireValues['text'],
					icon: "info",
					buttonsStyling: false,
					confirmButtonText: swalFireValues['confirmButtonText'],
					showCancelButton: true,
					cancelButtonText: swalFireValues['cancelButtonText'],
					customClass: {
						confirmButton: "btn btn-fj-orange",
						cancelButton: "btn btn-light"
					}
				}).then(function (result) {
					if (result.isConfirmed) {
						el.remove()
					}
				});
			// Si la opcion no tiene respuestas aun, puede ser eliminada
			} else {
				const swalFireValues = getTranslationValue(config, [language, "jQuery_document_function", "on_click_close_option", "Swalfire_2"], {
                    titleText: "Atención",
                    text: "¿Desea eliminar esta opción? Ésta acción se realizará cuando se actualice la oferta.",
                    confirmButtonText: "Entendido",
                    cancelButtonText: "Cancelar"
                })

				Swal.fire({
					titleText: swalFireValues['titleText'],
					text: swalFireValues['text'],
					icon: "warning",
					buttonsStyling: false,
					confirmButtonText: swalFireValues['confirmButtonText'],
					showCancelButton: true,
					cancelButtonText: swalFireValues['cancelButtonText'],
					customClass: {
						confirmButton: "btn btn-danger",
						cancelButton: "btn btn-light"
					}
				}).then(function (result) {
					if (result.isConfirmed) {
						el.remove()
					}
				});
			}
		} else {
			el.remove()
		}
  	})

	// Elimina una pregunta
	$("#kt_wizard_ofert #ofert-form").on("click", ".delete-option", function(e){
		e.preventDefault()

		var el = $(this).parent()
		// Esto se ejecuta si esta en la vista de editar oferta
		var checkIfEditForm = $("#ofert-form.form-edit-ofert").length
		// Si esta en la vista muestra la alerta de que va a eliminar una pregunta
		if(checkIfEditForm > 0){
			// Revisamos si esta preguntas se puede archivar
			var isArchived = $(this).hasClass("not-delete")
			// Si la pregunta ya tiene respuestas solo se puede archivar
			if(isArchived) {
				const swalFireValues = getTranslationValue(config, [language, "jQuery_document_function", "on_click_delete_option", "Swalfire_1"], {
                    titleText: "Importante",
                    text: "Ésta pregunta ya tiene respuestas por parte de los postulantes, no podremos eliminarla pero si estará archivada para que no se pierda la información.",
                    confirmButtonText: "Entendido",
                    cancelButtonText: "Cancelar"
                })

				Swal.fire({
					titleText: swalFireValues['titleText'],
					text: swalFireValues['text'],
					icon: "info",
					buttonsStyling: false,
					confirmButtonText: swalFireValues['confirmButtonText'],
					showCancelButton: true,
					cancelButtonText: swalFireValues['cancelButtonText'],
					customClass: {
						confirmButton: "btn btn-fj-orange",
						cancelButton: "btn btn-light"
					}
				}).then(function (result) {
					if (result.isConfirmed) {
            el.remove();
            set_id_fields();
						set_position_fields();
					}
				});
			// Si la pregunta no tiene respuestas aun, puede ser eliminada
			} else {
				const swalFireValues = getTranslationValue(config, [language, "jQuery_document_function", "on_click_delete_option", "Swalfire_2"], {
                    titleText: "Atención",
                    text: "¿Desea eliminar esta pregunta? Ésta acción se realizará cuando se actualice la oferta.",
                    confirmButtonText: "Eliminar",
                    cancelButtonText: "Cancelar"
                })

				Swal.fire({
					titleText: swalFireValues['titleText'],
					text: swalFireValues['text'],
					icon: "warning",
					buttonsStyling: false,
					confirmButtonText: swalFireValues['confirmButtonText'],
					showCancelButton: true,
					cancelButtonText: swalFireValues['cancelButtonText'],
					customClass: {
						confirmButton: "btn btn-danger",
						cancelButton: "btn btn-light"
					}
				}).then(function (result) {
					if (result.isConfirmed) {
            el.remove();
            set_id_fields();
						set_position_fields();
					}
				});
			}
		} else {
      el.remove();
      set_id_fields();
			set_position_fields();
    }
  })

	$('div#sandboxModal').on("click", "#load_questions", function(e){
    	const disabledText = getTranslationValue(config, [language, "jQuery_document_function", "on_click_load_questions"],"Enviando Información...")
		$(this).addClass("disabled").text(disabledText);
		$("div#sandboxModal").addClass("disabled");
	})

	$("#sandboxModal #sandbox_view").on("click", ".delete-button", function(e){
		deleteFilterQuestion('#sandboxModal', $(this).attr("data-id"));
	})

	$("#sandboxKillerModal #sandbox_view").on("click", ".delete-button", function(e){
		deleteFilterQuestion('#sandboxKillerModal', $(this).attr("data-id"));
	})

	function updateCountElements(selector, countPrefix) {
		$(selector).each(function(index) {
		  $(this).attr("id", countPrefix + (index + 1));
		  $(this).html(index + 1);
		});
	}
	  
	var set_id_fields = function() {
		updateCountElements("span.count", "count_");
		updateCountElements("span.count_killer", "count_");
	};

	var set_position_fields = function(){
    $(".hidden_position").each(function( index ) {
      $(this).val(index);
    });
  }

	// Envio de creacion/edicion de oferta
	$("#kt_wizard_ofert #ofert-form").on("click", ".action-submit", function(e){
		const disabledText = getTranslationValue(config, [language, "jQuery_document_function", "on_click_action_submit"],"Enviando Información...")
		$(this).addClass("disabled").text(disabledText);
		$("#kt_wizard_ofert #ofert-form").addClass("disabled")
		$("#kt_wizard_ofert #ofert-form").submit();
	})

	// Activa/desactiva campo para ingresar url de cuestionario externo
	$("#kt_wizard_ofert #ofert-form").on("click", "#ofert_link_is_external", function(){
		// Revisa si ha sido checkeado
		var isChecked = $('#kt_wizard_ofert #ofert-form #ofert_link_is_external:checked').length;
		// Se instancia la variable urlInput con el input de la url
		var urlInput = $('#kt_wizard_ofert #ofert-form #ofert_link_url')
		// Si activa el campo
		if(isChecked){
			// Quita la clase disabled al input para ingresar la url
			urlInput.removeClass("disabled")
			urlInput.removeClass("optional")
		// Si deaactiva el campo
		} else {
			// Agrega la clase disabled al input para ingresar la url
			urlInput.addClass("disabled")
			urlInput.addClass("optional")
		}

	})

	// Manejo del selector de rangos de salario
	$("#kt_wizard_ofert #ofert-form").on("change", "#ofert_enum_type", function(e){
		var $rangeSalary = $("#kt_wizard_ofert #ofert-form #ofert_range_salary");
		var radioOfertType = $("#ofert-form #ofert_enum_type input:checked")
		$rangeSalary.removeClass("disabled");
		$rangeSalary.html("");
	
		const defaultOptionText = getTranslationValue(config, [language, "jQuery_document_function", "on_change_ofert_enum_type_default_option"],"Seleccione una opción...")
		var $defaultOption = '<option value="">'+defaultOptionText+'</option>';
		$rangeSalary.append($defaultOption);
	
		var typeJob = radioOfertType.length > 0 ? radioOfertType.val() : $(this).val();
	
		if (typeJob == 0 || typeJob == '0'){
			var salary_ranges = {
				"> 80 USD": "> 80 USD",
				"80 - 100 USD": "80 - 100 USD",
				"100 - 130 USD": "100 - 130 USD",
				"130 - 150 USD": "130 - 150 USD",
				"150 - 200 USD": "150 - 200 USD",
				"200 - 250 USD": "200 - 250 USD",
				"250 - 300 USD": "250 - 300 USD",
				"300 - 350 USD": "300 - 350 USD",
				"350 - 400 USD": "350 - 400 USD",
				"400 - 450 USD": "400 - 450 USD",
				"450 - 500 USD": "450 - 500 USD",
				"500 - 600 USD": "500 - 600 USD",
				"600 - 700 USD": "600 - 700 USD",
				"700 - 800 USD": "700 - 800 USD",
				"800 - 900 USD": "800 - 900 USD",
				"Más de 900 USD": "Más de 900 USD"
			}
	
			setOptionsSalary(salary_ranges, $rangeSalary)
	
		} else if (typeJob == 1 || typeJob == '1'){
			var salary_ranges = {
				"400 - 500 USD": "400 - 500 USD",
				"500 - 600 USD": "500 - 600 USD",
				"600 - 700 USD": "600 - 700 USD",
				"700 - 800 USD": "700 - 800 USD",
				"800 - 900 USD": "800 - 900 USD",
				"900 - 1,000 USD": "900 - 1,000 USD",
				"1,000 - 1,100 USD": "1,000 - 1,100 USD",
				"1,100 - 1,200 USD": "1,100 - 1,200 USD",
				"1,200 - 1,300 USD": "1,200 - 1,300 USD",
				"1,300 - 1,400 USD": "1,300 - 1,400 USD",
				"1,400 - 1,500 USD": "1,400 - 1,500 USD",
				"1,500 - 1,600 USD": "1,500 - 1,600 USD",
				"1,600 - 1,700 USD": "1,600 - 1,700 USD",
				"1,700 - 1,800 USD": "1,700 - 1,800 USD",
				"1,800 - 1,900 USD": "1,800 - 1,900 USD",
				"1,900 - 2,000 USD": "1,900 - 2,000 USD",
				"Más de 2,000 USD": "Más de 2,000 USD"
			}
	
			setOptionsSalary(salary_ranges, $rangeSalary)
	
		} else if (typeJob == 2 || typeJob == '2'){
			var salary_ranges = {
				"400 - 500 USD": "400 - 500 USD",
				"500 - 600 USD": "500 - 600 USD",
				"600 - 700 USD": "600 - 700 USD",
				"700 - 800 USD": "700 - 800 USD",
				"800 - 900 USD": "800 - 900 USD",
				"900 - 1,000 USD": "900 - 1,000 USD",
				"1,000 - 1,100 USD": "1,000 - 1,100 USD",
				"1,100 - 1,200 USD": "1,100 - 1,200 USD",
				"1,200 - 1,300 USD": "1,200 - 1,300 USD",
				"1,300 - 1,400 USD": "1,300 - 1,400 USD",
				"1,400 - 1,500 USD": "1,400 - 1,500 USD",
				"1,500 - 1,600 USD": "1,500 - 1,600 USD",
				"1,600 - 1,700 USD": "1,600 - 1,700 USD",
				"1,700 - 1,800 USD": "1,700 - 1,800 USD",
				"1,800 - 1,900 USD": "1,800 - 1,900 USD",
				"1,900 - 2,000 USD": "1,900 - 2,000 USD",
				"Más de 2,000 USD": "Más de 2,000 USD"
			}
	
			setOptionsSalary(salary_ranges, $rangeSalary)
	
		} else if (typeJob == 3 || typeJob == '3'){
			var salary_ranges = {
				"> 80 USD": "> 80 USD",
				"80 - 100 USD": "80 - 100 USD",
				"100 - 130 USD": "100 - 130 USD",
				"130 - 150 USD": "130 - 150 USD",
				"150 - 200 USD": "150 - 200 USD",
				"200 - 250 USD": "200 - 250 USD",
				"250 - 300 USD": "250 - 300 USD",
				"300 - 350 USD": "300 - 350 USD",
				"350 - 400 USD": "350 - 400 USD",
				"400 - 450 USD": "400 - 450 USD",
				"450 - 500 USD": "450 - 500 USD",
				"500 - 600 USD": "500 - 600 USD",
				"600 - 700 USD": "600 - 700 USD",
				"700 - 800 USD": "700 - 800 USD",
				"800 - 900 USD": "800 - 900 USD",
				"Más de 900 USD": "Más de 900 USD"
			}
	
			setOptionsSalary(salary_ranges, $rangeSalary)
	
		} else {
			$rangeSalary.addClass("disabled");
		}
	
	});

	function setOptionsSalary(salary_ranges, rangeSalary){
		$.each(salary_ranges, function(key, value){
			var $option = '<option value="'+key+'">'+value+'</option>';
			rangeSalary.append($option);
		})
	}

	function deleteFilterQuestion(modalId, sandboxQuestionID) {
		const _typeUser = $(modalId).hasClass("admin") ? "admin" : "recruiter"
		Swal.fire({
			title: '¿Desea eliminar la Pregunta?',
			text: "Esta acción no se puede revertir.",
			icon: 'warning',
			allowEscapeKey: false,
			allowEnterKey: false,
			buttonsStyling: false,
			allowOutsideClick: false,
			confirmButtonText: "Entendido",
			showCancelButton: true,
			cancelButtonText: "Cancelar",
			customClass: {
				confirmButton: "btn btn-fj-purple",
				cancelButton: "btn btn-light"
			}
		}).then((result) => {
			if (result.isConfirmed) {
				// Consulta ajax
				const url = _typeUser == "recruiter" ? "/sandbox_oferts/"+sandboxQuestionID : "/admin/sandbox_oferts/"+sandboxQuestionID
				$.ajax({
					type: "DELETE",
					url: url,
					dataType: 'json',
					data: {
						authenticity_token: AUTH_TOKEN
					}
				}).done(function(response, textStatus, jqXHR) {
					Swal.fire({
						title: '¡Eliminado!',
						text: response['message'] || 'Pregunta eliminada exitosamente',
						icon: 'success',
						allowEscapeKey: false,
						allowEnterKey: false,
						buttonsStyling: false,
						allowOutsideClick: false,
						customClass: {
							confirmButton: "btn btn-fj-purple",
						}
					}).then(() => {
						$(modalId+' #sandbox_view  tr[data-id="'+sandboxQuestionID+'"]').remove();
					})
				}).fail(function(jqXHR, textStatus, errorThrown) {
					// Muestra alerta indicando que hay un error
					const swalFireText = jqXHR.responseJSON && jqXHR.responseJSON['message'] ? jqXHR.responseJSON['message'] : "Lo sentimos!, Hubo un problema y no se pudo eliminar la pregunta frecuente. Por favor inténtalo mas tarde.";
					Swal.fire({
						text: swalFireText,
						icon: "error",
						buttonsStyling: false,
						confirmButtonText: "Aceptar",
						customClass: {
							confirmButton: "btn btn-fj-purple"
						}
					})
				});
			}
		})
	}

	/*************
  	* FIN CREAR / EDITAR OFERTA
  	*/
});

function getTranslationValue(config, keys, defaultValue) {
	// Se agrego esta validacion para que Mutation Observer no rompiera la traduccion
	if (!config) return defaultValue;
	if (keys.length <= 1) return defaultValue;

	let currentTranslation;
	let firstIteration = true;

	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {

      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}

